(function () {
  var API_KEY = 'phc_B7urcNnnDD5zztztC3CJTdU9Hzu9otjdLCA4H4vLbjgh';
  var ENDPOINT = 'https://eu.i.posthog.com/capture/';

  function send(eventName) {
    try {
      var ph = window.posthog;
      var props = {
        distinct_id: (ph && ph.get_distinct_id) ? ph.get_distinct_id() : 'anon',
        source_page: window.location.pathname
      };
      if (ph && ph.get_session_id) { props.$session_id = ph.get_session_id(); }
      var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) { props.product_handle = m[1]; }
      navigator.sendBeacon(
        ENDPOINT,
        new Blob([JSON.stringify({ api_key: API_KEY, event: eventName, properties: props })], { type: 'text/plain' })
      );
    } catch (err) {}
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.lp-lock-btn');
    if (!link) return;
    send(link.textContent.trim().toLowerCase().indexOf('registrieren') !== -1
      ? 'Registration Started'
      : 'Login Clicked');
  }, true);

  function whenReady(cb, tries) {
    tries = tries || 0;
    if (window.posthog && posthog.get_distinct_id && posthog.get_distinct_id()) { cb(); return; }
    if (tries < 20) { setTimeout(function () { whenReady(cb, tries + 1); }, 250); }
  }

  if (document.querySelector('.lp-lock-note')) {
    whenReady(function () { send('Fachkreis Sperre gesehen'); });
  }
})();